export default {
  getMenus : (state) => { return state.data; },
}
